import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';

import { AppCommonsModule } from '../../app-commons.module';
import { PlessSharedModule } from '../../../shared/pless-shared.module';

import { KYMW0908Component } from './kymw0908.component';
import { GetCouponGoodsNoService } from './api-services/get-coupon-goods-no.service';

/**
 * プロモ設定画面 クーポン商品モジュール設定クラス
 *
 * @export KYMW0908Module
 * @class KYMW0908Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AppCommonsModule,
    PlessSharedModule,
    WjNavModule,
    WjGridModule,
    WjInputModule,
  ],
  declarations: [
    KYMW0908Component,
  ],
  providers: [
    GetCouponGoodsNoService,
  ],
})
export class KYMW0908Module { }
